<template>
  <v-tooltip bottom v-if="!hasLocale">
    <template v-slot:activator="{ on }">
      <v-icon :class="'no-locale ' + additionalClass" v-on="on">warning</v-icon>
    </template>
    <span>{{ this.$t("global.no_locale", { locale: this.currentLocale.toUpperCase() }) }}</span>
  </v-tooltip>
</template>

<script>
export default {
  inheritAttrs: true,

  computed: {
    currentLocale: {
      get() {
        return this.$getSetting("locale")
      }
    }
  },

  props: {
    hasLocale: {
      type: Boolean,
      required: true
    },

    additionalClass: {
      type: String
    }
  }
}
</script>
